export default {
    namespaced: true,
    state: () => ({
        ipversionlist: ['IPv4', 'IPv6'],
    }),
    mutations:
    {
        SET_IPVERLIST(state, val) {
            state.ipversionlist = val
        },
    }
}